import { render } from "./SnapshotVersion.vue?vue&type=template&id=70239881&scoped=true"
import script from "./SnapshotVersion.vue?vue&type=script&lang=js"
export * from "./SnapshotVersion.vue?vue&type=script&lang=js"

import "./SnapshotVersion.vue?vue&type=style&index=0&id=70239881&lang=scss&scoped=true"

import exportComponent from "D:\\software\\jenkins_home\\.jenkins\\workspace\\dev\\vls\\html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70239881"]])

export default __exports__